<template>
	<div class="newListDiv margin-t50">
    <div class="comTitle">
        <p>人事政策</p>
        <span>PERSONNEL POLICY</span>
        <em></em>
    </div>
		<ul class="newListUl">
			<li v-for="(item,index) in rszcList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
		    <router-link  :to="item.Url" :href="item.Url">
		      <div class="titles flexDiv">
		        <span>{{item.Title}}</span>
		        <i>{{item.ShowTime}}</i>
		      </div>
		      <p>{{item.Describe}}</p>
		    </router-link>
			</li>
		</ul>
    <a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s">
    	<router-link :to="moreLink"><i>查看更多+</i></router-link>
    </a>
	</div>
</template>

<script>
	export default{
		name:'rszc',
		props:{
			rszcList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/components/rszc.vue